import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface SignData {
  // documentId?: string;
  pdfUrl: string;
  signatureDetail: any;
  name: string;
  esignType?: string;
  navigate?: string;
  signerIndex?: number;
  editable?: boolean;
}

export interface Signer {
  name: string;
  email: string;
  esignType: string;
  phone: string;
  signatureDetail: any[];
}

@Injectable({
  providedIn: 'root'
})
export class DocumentService {

  constructor(private http: HttpClient) { }
  private apiUrl = `${environment.apiUrl}`;

  getAllDocument(paramsObj?: any) {
    let params = new HttpParams();

    if (paramsObj) {
      Object.keys(paramsObj).forEach(key => {
        const value = paramsObj[key];
        if (value !== null && value !== undefined && value !== '') {
          params = params.set(key, value);
        }
      });
    }
    return this.http.get(`${this.apiUrl}/documents`, { params })
  }

  getDocumentDetail(id: any) {
    return this.http.get(`${this.apiUrl}/documents/${id}`);
  }

  private _signers: Signer[] = [];

  get getSigners(): Signer[] {
    return this._signers;
  }

  set setSigners(value: Signer[]) {
    this._signers = value || [];
  }

}
